var pt = pt || {};
pt.blocografico = pt.blocografico || {};
pt.blocografico.modules = pt.blocografico.modules || {};
pt.blocografico.modules.contacts = pt.blocografico.modules.contacts || {};
pt.blocografico.modules.contacts = (function () {

  function buildCustomSelect(select) {
    var wrapper = document.createElement("div");
    wrapper.className = "custom-select-wrapper";

    var trigger = document.createElement("div");
    trigger.className = "custom-select-trigger";

    var triggerText = document.createElement("span");
    triggerText.textContent = select.options[select.selectedIndex]
      ? select.options[select.selectedIndex].text
      : "";
    trigger.appendChild(triggerText);

    var arrow = document.createElement("div");
    arrow.className = "custom-select-arrow";
    trigger.appendChild(arrow);

    var optionsList = document.createElement("div");
    optionsList.className = "custom-select-options";

    Array.prototype.forEach.call(select.options, function (opt) {
      var item = document.createElement("div");
      item.className = "custom-select-option";
      if (opt.selected) item.classList.add("selected");
      item.textContent = opt.text;
      item.dataset.value = opt.value;
      item.addEventListener("click", function () {
        select.value = opt.value;
        triggerText.textContent = opt.text;
        optionsList.querySelectorAll(".custom-select-option").forEach(function (el) {
          el.classList.remove("selected");
        });
        item.classList.add("selected");
        wrapper.classList.remove("is-open");
        var event = new Event("change", { bubbles: true });
        select.dispatchEvent(event);
      });
      optionsList.appendChild(item);
    });

    trigger.addEventListener("click", function (e) {
      e.stopPropagation();
      var isOpen = wrapper.classList.contains("is-open");
      document.querySelectorAll(".custom-select-wrapper.is-open").forEach(function (el) {
        el.classList.remove("is-open");
      });
      if (!isOpen) wrapper.classList.add("is-open");
    });

    wrapper.appendChild(trigger);
    wrapper.appendChild(optionsList);
    select.parentNode.insertBefore(wrapper, select);
    wrapper.appendChild(select);

    // Mirror invalid class from select to wrapper
    var observer = new MutationObserver(function () {
      if (select.classList.contains("invalid")) {
        wrapper.classList.add("invalid");
      } else {
        wrapper.classList.remove("invalid");
      }
    });
    observer.observe(select, { attributes: true, attributeFilter: ["class"] });
  }

  function init() {
    const validationContact = {
      "requisitar_contacto[nome]": {
        rules: { required: false, minLength: 2, maxLength: 50 },
      },
      "requisitar_contacto[email]": {
        rules: { required: true, customValidator: "email" },
      },
      "requisitar_contacto[assuntos][0]": {
        rules: { required: true },
      },
      "requisitar_contacto[comentario]": {
        rules: { required: true, minLength: 2, maxLength: 1600 },
      },
    };
    let formId = "request-contact-form";
    let formContact = document.getElementById(formId);

    // Convert native selects to custom dropdowns
    formContact.querySelectorAll("select.subject").forEach(function (select) {
      buildCustomSelect(select);
    });

    // Close dropdowns when clicking outside
    document.addEventListener("click", function () {
      document.querySelectorAll(".custom-select-wrapper.is-open").forEach(function (el) {
        el.classList.remove("is-open");
      });
    });

    let formContactFields = formContact.querySelectorAll(`input`);

    formContactFields.forEach((element) => {
      element.addEventListener("change", () => {
        pt.blocografico.library.form.validator.validateSingleField(formId, validationContact, element.name);
      });
    });

    let formContactButtonSubmitId = "contact-form-submit";
    let formContactButtonSubmit = document.getElementById(formContactButtonSubmitId);

    formContactButtonSubmit.addEventListener("click", (event) => {
      event.preventDefault();

      pt.blocografico.library.form.validator.validateFields(
        formId,
        validationContact,
        () => pt.blocografico.modules.contacts.sendForm(formContact),
        () => {}
      );
    });
  }

  function sendForm(formContact) {
    const isTurnstile = !!formContact.querySelector(".cf-turnstile");
    document.getElementById("recaptcha").value = isTurnstile ? turnstile.getResponse() : grecaptcha.getResponse();
    const formData = new FormData(formContact);
    fetch("/middleman/form", {
      method: "POST",
      body: formData,
    })
      .then((response) => {
        if (isTurnstile) { turnstile.reset(); } else { grecaptcha.reset(); }
        document.getElementById("recaptcha").value = "";
        if (!response.ok) {
          // mostra a mensagem de erro
          let element = document.getElementById("msg-error");
          element.style.display = "flex";
          setTimeout(function () {
            element.style.display = "none";
          }, 10000);

          return;
        }
        formContact.reset();

        let element = document.getElementById("msg-success");
        formContact.style.display = "none";
        element.style.display = "flex";
        setTimeout(function () {
          formContact.style.display = "flex";
          element.style.display = "none";
        }, 10000);

        response.json();
      })
      .then((data) => {});
  }


  return { init, sendForm };
})();

document.addEventListener("DOMContentLoaded", function () {
  pt.blocografico.modules.contacts.init();
});
